"use client";

import React from "react";
import type { TabContentProps } from "@/components/shared/UniversalDetailPage/types/detailPage";
import type { Ticket } from "@/lib/types/database";
import { TicketUpdatesList } from "../TicketUpdatesList";

/**
 * Ticket Updates Tab Component — organized, date-grouped ticket_updates list
 * with type badges, internal flags, author attribution, and an Add Update CTA.
 */
export const TicketUpdatesTab = React.memo(({ item }: TabContentProps<Ticket>) => {
  // Guard against undefined or null item
  if (!item) {
    return <div className="text-sm text-gray-500">Loading ticket updates...</div>;
  }

  return (
    <TicketUpdatesList
      ticketId={item.id}
      ticketNumber={(item as { ticket_number?: number | string }).ticket_number?.toString()}
    />
  );
});

TicketUpdatesTab.displayName = "TicketUpdatesTab";
